<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from 'axios'


export default {
  name: 'App',
  created () {
    this.getShareInfo();
  },
  methods: {
    // getSing(url) {

    // },

    getShareInfo () {
      //获取url链接（如果有#需要这么获取）
      // var url = encodeURIComponent(window.location.href.split("#")[0]);
      var url = encodeURI(window.location);
      //获取url链接（如果没有#需要这么获取）// var url = encodeURIComponent(window.location.href);
      axios({
        method: 'get',
        url: 'https://www.iceriverbj.com/comon/wxshare.php',
        params: { url }
      }).then(res => {
        console.log(res);
        const { timestamp, nonceStr, signature } = res.data
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: 'wx14363d832a1e5052',
          // 必填，公众号的唯一标识
          timestamp: parseInt(timestamp),
          // 必填，生成签名的时间戳
          nonceStr,
          // 必填，生成签名的随机串
          signature,
          // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          // 必填，需要使用的 JS 接口列表
        });
        wx.ready(() => {
          var shareData = { title: "冰河传媒", desc: "一站式会展服务平台", link: window.location.href, imgUrl: "https://image.iceriverbj.com/gw/logoaaa.png" };
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData(shareData);
          //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
          wx.updateTimelineShareData(shareData);
        });
        //错误了会走 这里
        wx.error(function (res) { console.log("微信分享错误信息", res) })
      })
    }
  },
}
</script>

<style>
#container {
  background-image: url("./assets/img/erjibj.png");
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue